import { render, staticRenderFns } from "./TemplateManagement.vue?vue&type=template&id=1658dace&scoped=true&"
import script from "./TemplateManagement.vue?vue&type=script&lang=js&"
export * from "./TemplateManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1658dace",
  null
  
)

export default component.exports